module.exports = __webpack_public_path__ + "img/logoirsmarket.33a0883e.png";